import {CONFIG, Screen} from './config';

/**
 * Are we on one of the provided screens?
 */
export const isScreen = ( screens: Array<Screen> ): boolean => {
	return screens.includes( CONFIG.currentScreen );
};
